export const json = {
  locale: 'de_de',
  recipe: "Rezept",
  machine: "Maschine",
  task: {
    state: {
      unset: "Nicht festgelegt",
      todo: "Zu erledigen",
      in_progress: "In Bearbeitung",
      to_test: "Zu testen",
      wont_fix: "Wird nicht behoben",
      done: "Erledigt",
      paused: "Pausiert",
    },
    priority: {
      unset: "Keine Priorität",
      low: "Niedrig",
      normal: "Normal",
      high: "Hoch",
      max: "Dringend",
    },
    table: {
      header: {
        title: "Aufgabe",
        state: "Status",
        priority: "Priorität",
        labels: "Etiketten",
      },
      placeholder: {
        filter: {
          priority: "E-Mails filtern...",
        },
      },
      "no-results": "Keine Ergebnisse",
    },
    add: {
      title: "Neue Aufgabe hinzufügen",
      name: "Aufgabenname",
      name_placeholder: "Aufgabenname eingeben",
      priority: "Priorität",
      title_translations: "Titelübersetzungen",
      description_translations: "Beschreibungsübersetzungen",
      icon_url: "Symbol-URL (optional)",
      icon_url_placeholder: "Symbol-URL eingeben",
      labels: "Etiketten",
      assigned_to: "Zugewiesen an",
      assigned_to_placeholder: "Moderator auswählen",
      submit: "Aufgabe erstellen",
      cancel: "Abbrechen",
      edit_translations: "Übersetzungen bearbeiten",
      save_translations: "Übersetzungen speichern",
      required_field: "Dieses Feld ist erforderlich",
      en_us_required: "Englische (US) Übersetzung ist erforderlich",
      success: "Aufgabe erfolgreich erstellt!",
      error: "Fehler beim Erstellen der Aufgabe. Bitte versuchen Sie es erneut.",
    },
  },
  table: {
    select: {
      of: "von",
      rows: "Zeile(n) ausgewählt.",
    },
  },
  cookies: {
    link: 'Cookie-Richtlinie',
    title: "Cookie-Zustimmung",
    description:
      "Diese Website verwendet Cookies, um ihr ordnungsgemäßes Funktionieren zu gewährleisten und Ihre Erfahrung zu verbessern. Bitte wählen Sie aus, welche Cookies wir verwenden dürfen.",
    policy_link: "Erfahren Sie mehr in unserer Cookie-Richtlinie",
    accept_all: "Alle akzeptieren",
    accept_selected: "Ausgewählte akzeptieren",
    accept_essential: "Nur essentielle",
    manage: "Einstellungen verwalten",
    save: "Einstellungen speichern",
    back: "Zurück",
    categories: {
      essential: {
        title: "Essentielle Cookies",
        description: "Diese Cookies sind für das Funktionieren der Website notwendig und können nicht deaktiviert werden.",
      },
      functional: {
        title: "Funktionale Cookies",
        description: "Diese Cookies ermöglichen personalisierte Funktionen und Merkmale.",
      },
      analytics: {
        title: "Analyse-Cookies",
        description: "Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren.",
      },
      marketing: {
        title: "Marketing-Cookies",
        description: "Diese Cookies werden verwendet, um Besucher über Websites hinweg für Werbezwecke zu verfolgen.",
      },
    },
    expiration: {
      title: "Cookie-Ablauf",
      description: "Wählen Sie, wie lange Ihre Cookie-Einstellungen gespeichert werden sollen:",
      thirty_days: "30 Tage",
      ninety_days: "90 Tage",
      six_months: "6 Monate",
      one_year: "1 Jahr",
    },
    policy: {
      title: "Cookie-Richtlinie",
      introduction:
        "Diese Cookie-Richtlinie erklärt, wie wir Cookies und ähnliche Technologien verwenden, um Sie zu erkennen, wenn Sie unsere Website besuchen. Sie erklärt, was diese Technologien sind und warum wir sie verwenden, sowie Ihre Rechte zur Kontrolle unserer Verwendung dieser Technologien.",
      what_are_cookies: "Was sind Cookies?",
      what_are_cookies_text:
        "Cookies sind kleine Datendateien, die auf Ihrem Computer oder mobilen Gerät platziert werden, wenn Sie eine Website besuchen. Cookies werden von Website-Betreibern häufig verwendet, um ihre Websites funktionsfähig zu machen oder effizienter zu arbeiten, sowie um Berichtsinformationen bereitzustellen.",
      how_we_use: "Wie wir Cookies verwenden",
      how_we_use_text:
        "Wir verwenden Cookies aus mehreren Gründen. Einige Cookies sind aus technischen Gründen erforderlich, damit unsere Website funktioniert, und wir bezeichnen diese als 'essentielle' oder 'notwendige' Cookies. Andere Cookies ermöglichen es uns, die Interessen unserer Benutzer zu verfolgen und zu fokussieren, um die Erfahrung auf unserer Website zu verbessern. Dritte stellen Cookies über unsere Website für Werbung, Analysen und andere Zwecke bereit.",
      types: "Arten von Cookies, die wir verwenden",
      managing: "Verwaltung Ihrer Cookies",
      managing_text:
        "Sie können die Steuerelemente Ihres Webbrowsers einstellen oder ändern, um Cookies zu akzeptieren oder abzulehnen. Wenn Sie sich entscheiden, Cookies abzulehnen, können Sie unsere Website weiterhin nutzen, obwohl Ihr Zugriff auf einige Funktionen und Bereiche unserer Website möglicherweise eingeschränkt ist. Da die Mittel, mit denen Sie Cookies über die Steuerelemente Ihres Webbrowsers ablehnen können, von Browser zu Browser variieren, sollten Sie das Hilfemenü Ihres Browsers besuchen, um weitere Informationen zu erhalten.",
      third_party: "Cookies von Drittanbietern",
      third_party_text:
        "Zusätzlich zu unseren eigenen Cookies können wir auch verschiedene Cookies von Drittanbietern verwenden, um Nutzungsstatistiken der Website zu melden, Werbung auf und über die Website zu liefern und so weiter.",
      updates: "Aktualisierungen dieser Cookie-Richtlinie",
      updates_text:
        "Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren, um beispielsweise Änderungen an den von uns verwendeten Cookies oder aus anderen betrieblichen, rechtlichen oder regulatorischen Gründen widerzuspiegeln. Bitte besuchen Sie diese Cookie-Richtlinie daher regelmäßig erneut, um über unsere Verwendung von Cookies und verwandten Technologien informiert zu bleiben.",
      purpose: "Zweck",
      essential_purpose:
        "Notwendig für das ordnungsgemäße Funktionieren der Website. Diese Cookies ermöglichen grundlegende Funktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Website.",
      functional_purpose:
        "Ermöglichen der Website, sich an Entscheidungen zu erinnern, die Sie treffen (wie Ihren Benutzernamen, Ihre Sprache oder die Region, in der Sie sich befinden), und bieten erweiterte, persönlichere Funktionen.",
      analytics_purpose:
        "Helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem sie Informationen anonym sammeln und melden.",
      marketing_purpose:
        "Werden verwendet, um Besucher über Websites hinweg zu verfolgen. Die Absicht ist, Anzeigen anzuzeigen, die für den einzelnen Benutzer relevant und ansprechend sind.",
      always_active: "Immer aktiv",
      active: "Aktiv",
      inactive: "Inaktiv",
      back_to_site: "Zurück zur Website",
    },
  },
  sidebar: {
    platform: "Plattform",
    dashboard: "Dashboard",
    tasks: {
      title: "Aufgaben",
      add: "Aufgabe hinzufügen"
    },
    analytics: "Analysen",
    users: "Benutzer",
    settings: "Einstellungen",
    admin_panel: {
      title: "Admin-Panel",
      mods: {
        title: "Moderatoren",
        add: "Moderator hinzufügen"
      },
      labels: {
        title: "Etiketten",
        add: "Etikett hinzufügen"
      },
      pending: "Ausstehende Genehmigungen"
    },
    documentation: {
      title: "Dokumentationen",
      create: "Dokumentation erstellen"
    },
    search: "In Dokumenten suchen..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "Übersicht",
          userInfo: "Benutzerinformationen",
          userId: "Benutzer-ID",
          role: "Rolle",
          memberSince: "Mitglied seit"
        },
        tasks: {
          title: "Aufgaben",
          assigned: "Zugewiesene Aufgaben",
          noTasks: "Noch keine Aufgaben zugewiesen."
        },
        activity: {
          title: "Aktivität",
          recent: "Letzte Aktivität",
          noActivity: "Keine aktuelle Aktivität."
        },
        settings: {
          title: "Einstellungen",
          user: "Benutzereinstellungen",
          admin: "Admin-Einstellungen für diesen Benutzer."
        }
      }
    },
    mods: {
      error: {
        unknownError: "Unbekannter Fehler"
      },
      access: {
        title: "Zugriff verweigert",
        description: "Sie haben keine Berechtigung, auf diese Seite zuzugreifen."
      },
      add: {
        link: "Neuen Mod hinzufügen",
        title: "Neuen Mod hinzufügen",
        addDesc: "Einen neuen Mod-Eintrag erstellen",
        name: {
          title: "Name",
          placeholder: "Mod-Namen eingeben"
        },
        description: {
          title: "Beschreibung",
          placholder: "Beschreibung eingeben in "
        },
        optional: "Optional",
        versions: {
          title: "Versionen",
          add: "Version hinzufügen"
        },
        icon: "Symbol-URL",
        launchers: "Launcher",
        form: {
          errors: {
            alert: {
              title: "Fehler",
              description: "Bitte beheben Sie die obigen Fehler vor dem Absenden."
            },
            name: "Name ist erforderlich",
            description: "Englische (US) Beschreibung ist erforderlich",
            curseforge: "CurseForge-Link ist erforderlich",
            invalidURL: "Ungültiges URL-Format",
            versions: "Mindestens eine Version ist erforderlich",
            launchers: "Mindestens ein Launcher ist erforderlich"
          }
        },
        cancel: "Abbrechen",
        create: {
          loading: "Erstelle...",
          default: "Mod erstellen"
        },
        langDataError: "Fehler beim Laden der Sprachdaten:",
      },
      noMods: "Keine Mods gefunden",
      getStarted: "Beginnen Sie mit der Erstellung eines neuen Mods.",
      fetch: {
        error: 'Fehler beim Abrufen der Dokumentation:'
      },
      "delete": {
        link: "Löschen",
        confirm: "Sind Sie sicher, dass Sie diesen Mod löschen möchten?"
      },
      toast: {
        delete: {
          success: {
            title: "Mod gelöscht",
            description: "Der Mod wurde erfolgreich gelöscht."
          },
          error: {
            console: "Fehler beim Löschen des Mods:",
            fallback: "Fehler beim Löschen des Mods",
            title: "Fehler",
            description: "Beim Löschen des Mods ist ein Fehler aufgetreten."
          }
        },
        edit: {
          success: {
            title: "Erfolg",
            description: "Mod erfolgreich aktualisiert"
          }
        },
        add: {
          fallback: "Fehler beim Erstellen des Mods",
          success: {
            title: "Erfolg",
            description: "Mod erfolgreich erstellt"
          },
          console: "Fehler beim Erstellen des Mods:",
          error: {
            title: "Fehler",
            description: "Fehler beim Erstellen des Mods"
          }
        }
      },
      noDesc: "Keine Beschreibung verfügbar",
      docs: {
        link: "Dokumentation"
      },
      edit: {
        link: "Bearbeiten",
        title: "Mod bearbeiten",
        langDataError: "Fehler beim Laden der Sprachdaten:",
        notFound: "Mod nicht gefunden",
        failFetch: "Fehler beim Abrufen des Mods",
        unknownError: "Ein unbekannter Fehler ist aufgetreten",
        form: {
          errors: {
            name: "Name ist erforderlich",
            description: "Englische (US) Beschreibung ist erforderlich",
            curseforge: "CurseForge-Link ist erforderlich",
            versions: "Alle Versionsfelder müssen ausgefüllt sein",
            launchers: "Mindestens ein Launcher muss ausgewählt sein"
          }
        },
        modInfo: "Mod-Informationen",
        editModInfo: "Bearbeiten Sie die Mod-Informationen.",
        name: "Name",
        description: {
          title: "Beschreibung",
          required: "Englische (US) Beschreibung ist erforderlich."
        },
        optional: "Optional",
        versions: {
          title: "Versionen",
          add: "Version hinzufügen",
          remove: "Entfernen"
        },
        icon: "Symbol-URL",
        launchers: "Launcher",
        cancel: "Abbrechen",
        update: "Mod aktualisieren"
      }
    },
    docs: {
      access: {
        title: "Zugriff verweigert",
        description: "Sie haben keine Berechtigung, auf diese Seite zuzugreifen."
      },
      title: "Dokumentation",
      description: "Durchsuchen und lesen Sie Dokumentationen für Minecraft-Mods",
      create: {
        link: "Dokumentation erstellen",
        tab: "Neu erstellen",
        content: {
          title: "Keine Mods verfügbar",
          description: "Alle Mods haben bereits Dokumentation oder Sie haben keine Berechtigung, Dokumentation für einen Mod zu erstellen."
        },
        title: "Dokumentation erstellen"
      },
      published: "Veröffentlicht",
      pending: "Ausstehend",
      noDocs: {
        title: "Keine Dokumentation verfügbar",
        description: "Es gibt noch keine veröffentlichten Dokumentationsseiten."
      },
      noPending: {
        title: "Keine ausstehende Dokumentation",
        superAdmin: "Es gibt keine Dokumentationsseiten, die auf Genehmigung warten",
        rest: "Sie haben keine ausstehenden Dokumentationsseiten."
      },
      user: {
        noDocs: {
          title: "Keine Dokumentation verfügbar",
          description: "Es gibt noch keine veröffentlichten Dokumentationsseiten."
        }
      },
      card: {
        pending: "Genehmigung ausstehend",
        view: "Ansehen",
        edit: "Bearbeiten"
      },
      add: {
        title: "Neue Dokumentation erstellen",
        description: "Erstellen Sie umfassende Dokumentation für einen Minecraft-Mod",
        noMods: {
          title: "Keine Mods verfügbar",
          description: "Es sind keine Mods für die Dokumentationserstellung verfügbar. Entweder haben alle Mods bereits Dokumentation oder Sie haben keine Berechtigung, Dokumentation für einen Mod zu erstellen."
        },
        card: {
          title: "Grundlegende Informationen",
          description: "Geben Sie grundlegende Informationen über die Dokumentation an.",
          descriptionLink: "Sehen Sie sich unseren Dokumentationsleitfaden an",
          content: {
            modSelect: "Mod auswählen",
            modSelectDesc: "Wählen Sie den Mod aus, für den Sie Dokumentation erstellen möchten",
            noDesc: "Keine Beschreibung verfügbar",
            form: {
              title: {
                title: "Titel",
                placeholder: "Dokumentationstitel eingeben",
                description: "Der Titel Ihrer Dokumentation (Englisch US ist erforderlich)"
              },
              description: {
                title: "Beschreibung",
                placeholder: "Dokumentationsbeschreibung eingeben",
                description: "Eine kurze Beschreibung Ihrer Dokumentation (Englisch US ist erforderlich)"
              },
              coverImage: {
                title: "Cover-Bild-URL (Optional)",
                description: "Geben Sie eine URL für das Cover-Bild Ihrer Dokumentation an"
              },
              tabs: {
                preview: {
                  title: "Vorschau",
                  content: {
                    title: "Vorschau",
                    description: "Vorschau, wie Ihre Dokumentation aussehen wird",
                    form: {
                      title: "Dokumentationstitel",
                      description: "Die Dokumentationsbeschreibung wird hier erscheinen."
                    },
                    section: "Abschnitt",
                    article: "Artikel",
                    modSelect: {
                      title: "Mod auswählen",
                      description: "Wählen Sie einen Mod aus, um Ihre Dokumentation in der Vorschau anzuzeigen"
                    }
                  }
                },
                information: {
                  title: "Informationen",
                  content: {
                    title: "Informationen",
                    description: "Wichtige Informationen zur Dokumentationserstellung",
                    approval: {
                      title: "Genehmigung erforderlich",
                      description: "Von Bearbeitern und Administratoren erstellte Dokumentation erfordert die Genehmigung eines Super-Administrators, bevor sie öffentlich wird. Öffnen Sie ein Ticket, um dies anzufordern."
                    },
                    after: {
                      title: "Nach der Erstellung:",
                      list: {
                        one: "Sie werden zum Dokumentationseditor weitergeleitet",
                        two: "Ein Standardabschnitt und -artikel werden automatisch erstellt",
                        three: "Sie können bei Bedarf weitere Abschnitte und Artikel hinzufügen",
                        four: "Sie können Bilder hochladen und benutzerdefinierte Komponenten hinzufügen",
                        five: "Sie können Ihre Dokumentation vor der Einreichung zur Genehmigung in der Vorschau anzeigen. (Sie muss vor der Vorschau gespeichert werden)"
                      }
                    },
                    create: {
                      loading: "Erstelle...",
                      default: "Dokumentation erstellen"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "Fehler beim Abrufen der Mods",
          documentation: "Fehler beim Abrufen der Dokumentationen"
        },
        success: {
          title: "Dokumentation erstellt",
          description: "Ihre Dokumentation wurde erfolgreich erstellt."
        },
        error: {
          fetching: {
            mods: {
              console: "Fehler beim Abrufen der Mods:",
              toast: {
                title: "Fehler",
                description: "Fehler beim Laden der Mods. Bitte versuchen Sie es erneut."
              }
            }
          },
          creating: {
            failed: "Fehler beim Erstellen der Dokumentation",
            error: {
              console: "Fehler beim Erstellen der Dokumentation:",
              toast: {
                title: "Fehler",
                description: "Fehler beim Erstellen der Dokumentation. Bitte versuchen Sie es erneut."
              }
            }
          }
        }
      }
    }
  }
}